export const generateDynamicFormFields = <T>(count: number, object: T): T[] => {
  const fields = [];

  for (let i = 0; i < count; i++) {
    fields.push(object);
  }

  return fields;
};
